/**
 * Converts a relative S3 path like "brand-campaign-files/profile-photos/220/file.png"
 * into a full S3 URL: "https://brand-campaign-files.s3.ap-south-1.amazonaws.com/profile-photos/220/file.png"
 */
export const getS3ImageUrl = (s3Path) => {
    if (!s3Path) return null;
    // If it's already a full URL, return as-is (robust regex check)
    if (/^https?:\/\//i.test(s3Path.trim())) {
        return s3Path.trim();
    }
    // Format: {bucketName}/{key} → https://{bucketName}.s3.ap-south-1.amazonaws.com/{key}
    const firstSlash = s3Path.indexOf('/');
    if (firstSlash === -1) return s3Path;
    const bucket = s3Path.substring(0, firstSlash);
    const key = s3Path.substring(firstSlash + 1);
    return `https://${bucket}.s3.ap-south-1.amazonaws.com/${key}`;
};
